var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LinearProgress } from '@mui/material';
import { useAppDispatch, useAppSelector, useQuery } from '../../../../hooks';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { forceStartDay, getMatchState } from '../../../../api';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { ModalNew } from '../../../atoms/Modal/Modal';
import { DeskPool } from '../../DeskPool';
import { colors } from '../../../../styles/colors';
const ModalContent = styled.div `
  padding: 48px;
  background-color: #292c2e;
  max-width: 600px;
  width: 100%;
`;
const Title = styled.h1 `
  font-family: Bowler;
  font-size: 28px;
  line-height: 36px;
  color: #fff;
  margin-bottom: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;
const ProgressSection = styled.div `
  margin-bottom: 32px;
`;
const ProgressLabel = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  color: #fff;
  font-size: 18px;
`;
const UnacknowledgedSection = styled.div `
  background-color: rgba(23, 28, 31, 0.5);
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 32px;
  max-height: 300px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }
`;
const UnacknowledgedTitle = styled.h3 `
  color: #ffa726;
  font-size: 18px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const PlayersList = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;
`;
const PlayerItem = styled.li `
  color: #b0b0b0;
  font-size: 16px;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;

  &:before {
    content: '•';
    position: absolute;
    left: 0;
    color: #ffa726;
  }
`;
const ForceStartButton = styled.button `
  width: 100%;
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%);
  color: ${colors.textPrimary};
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.primary} 100%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const ConfirmModalContent = styled.div `
  padding: 32px;
  background-color: #292c2e;
  border-radius: 12px;
  max-width: 480px;
`;
const ConfirmModalTitle = styled.h2 `
  color: #fff;
  font-size: 24px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const ConfirmModalText = styled.p `
  color: #b0b0b0;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
`;
const ConfirmModalButtons = styled.div `
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;
const CancelButton = styled.button `
  background-color: ${colors.surface};
  border: 1px solid ${colors.cardBorder};
  color: ${colors.textPrimary};
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${colors.surfaceVariant};
    border-color: ${colors.primary};
  }
`;
const ConfirmButton = styled.button `
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%);
  color: ${colors.textPrimary};
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.primary} 100%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const SuccessMessage = styled.div `
  text-align: center;
  color: #66bb6a;
  font-size: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const SuccessSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const StartDayButton = styled.button `
  width: 100%;
  background-color: ${colors.success};
  color: ${colors.textPrimary};
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #16A34A;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export function MorningAcknowledgment() {
    const { param: matchId } = useQuery('matchId');
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const { errorHandler } = useErrorHandler(matchId);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isForceStarting, setIsForceStarting] = useState(false);
    const acknowledgmentState = matchState === null || matchState === void 0 ? void 0 : matchState.state;
    // Polling for updates
    useEffect(() => {
        const fetchMatchState = () => __awaiter(this, void 0, void 0, function* () {
            if (!matchId)
                return;
            try {
                const result = yield getMatchState(matchId);
                dispatch(setMatchState(result));
            }
            catch (e) {
                console.error('Failed to fetch match state:', e);
            }
        });
        // Initial fetch
        fetchMatchState();
        // Set up polling interval (every 2 seconds)
        const interval = setInterval(fetchMatchState, 2000);
        return () => clearInterval(interval);
    }, [matchId, dispatch]);
    const handleForceStart = () => __awaiter(this, void 0, void 0, function* () {
        if (!matchId)
            return;
        setIsForceStarting(true);
        try {
            const result = yield forceStartDay(matchId);
            dispatch(setMatchState(result));
            setShowConfirmModal(false);
        }
        catch (error) {
            errorHandler(error);
        }
        finally {
            setIsForceStarting(false);
        }
    });
    if (!acknowledgmentState) {
        return null;
    }
    const { unacknowledgedPlayers = [], totalPlayers = 0, acknowledgedCount = 0, acknowledgmentPercentage = 0, } = acknowledgmentState;
    // Determine progress bar color based on percentage
    const getProgressColor = () => {
        if (acknowledgmentPercentage < 30)
            return '#ff6b6b';
        if (acknowledgmentPercentage < 70)
            return '#ffa726';
        return '#66bb6a';
    };
    // Component to show in the modal
    const AcknowledgmentModal = () => (_jsxs(_Fragment, { children: [_jsx(ModalNew, Object.assign({ eventModal: true, onClose: () => null }, { children: _jsxs(ModalContent, { children: [_jsx(Title, { children: "\uD83C\uDF05 \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439" }), _jsxs(ProgressSection, { children: [_jsxs(ProgressLabel, { children: [_jsx("span", { children: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441:" }), _jsxs("span", { children: [acknowledgedCount, "/", totalPlayers, " (", Math.round(acknowledgmentPercentage), "%)"] })] }), _jsx(LinearProgress, { variant: "determinate", value: acknowledgmentPercentage, sx: {
                                        height: 12,
                                        borderRadius: 6,
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: getProgressColor(),
                                            borderRadius: 6,
                                        },
                                    } })] }), unacknowledgedPlayers.length > 0 ? (_jsxs(_Fragment, { children: [_jsxs(UnacknowledgedSection, { children: [_jsx(UnacknowledgedTitle, { children: "\u23F3 \u041E\u0436\u0438\u0434\u0430\u044E\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F:" }), _jsx(PlayersList, { children: unacknowledgedPlayers.map((player) => (_jsx(PlayerItem, { children: player.name }, player.id))) })] }), _jsx(ForceStartButton, Object.assign({ onClick: () => setShowConfirmModal(true), disabled: isForceStarting }, { children: "\u041D\u0430\u0447\u0430\u0442\u044C \u0434\u0435\u043D\u044C \u043F\u0440\u0438\u043D\u0443\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E" }))] })) : (_jsxs(SuccessSection, { children: [_jsx(SuccessMessage, { children: "\u2705 \u0412\u0441\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439" }), _jsx(StartDayButton, Object.assign({ onClick: handleForceStart, disabled: isForceStarting }, { children: isForceStarting ? 'Запуск...' : 'Начать день' }))] }))] }) })), showConfirmModal && (_jsx(ModalNew, Object.assign({ onClose: () => setShowConfirmModal(false) }, { children: _jsxs(ConfirmModalContent, { children: [_jsx(ConfirmModalTitle, { children: "\u26A0\uFE0F \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F" }), _jsxs(ConfirmModalText, { children: ["\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043D\u0430\u0447\u0430\u0442\u044C \u0434\u0435\u043D\u044C \u043F\u0440\u0438\u043D\u0443\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E?", _jsx("br", {}), _jsx("br", {}), unacknowledgedPlayers.length, " ", unacknowledgedPlayers.length === 1 ? 'игрок' : 'игрока', " \u0435\u0449\u0435 \u043D\u0435", unacknowledgedPlayers.length === 1 ? ' подтвердил' : ' подтвердили', " \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439."] }), _jsxs(ConfirmModalButtons, { children: [_jsx(CancelButton, Object.assign({ onClick: () => setShowConfirmModal(false) }, { children: "\u041E\u0442\u043C\u0435\u043D\u0430" })), _jsx(ConfirmButton, Object.assign({ onClick: handleForceStart, disabled: isForceStarting }, { children: isForceStarting ? 'Запуск...' : 'Начать день' }))] })] }) })))] }));
    // Game button state - пустая кнопка, так как основное действие в попапе
    const gameButtonState = {
        text: '',
        visible: false,
        onClick: () => { },
    };
    return (_jsx(DeskPool, { onPlayerClickAction: null, gameButtonState: gameButtonState, addOnComponent: AcknowledgmentModal }));
}
